import { render, staticRenderFns } from "./QuickTransformEditComponents.vue?vue&type=template&id=482b0c77&"
import script from "./QuickTransformEditComponents.vue?vue&type=script&lang=js&"
export * from "./QuickTransformEditComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports